import { NOTIFICATION_TYPE } from "@thrivecoin/adapter/dist/types";

export const handledNotifications = [
  NOTIFICATION_TYPE.GRANT_EXPIRED,
  NOTIFICATION_TYPE.GRANT_PUBLISHED,
  NOTIFICATION_TYPE.GRANT_EXPIRES_IN_ONE_DAY,
  NOTIFICATION_TYPE.GRANT_EXPIRES_IN_TWO_WEEKS,
  NOTIFICATION_TYPE.GRANT_APPLICATION_APPROVED,
  NOTIFICATION_TYPE.GRANT_APPLICATION_REJECTED,
  NOTIFICATION_TYPE.GRANT_APPLICATION_COMPLETED,
  NOTIFICATION_TYPE.GRANT_APPLICATION_CREATED,
  NOTIFICATION_TYPE.GRANT_APPLICATION_WITHDRAWN,
  NOTIFICATION_TYPE.CONTRACT_SENT,
  NOTIFICATION_TYPE.WALLET_VERIFIED,
  NOTIFICATION_TYPE.DELIVERABLE_REJECTED,
  NOTIFICATION_TYPE.DELIVERABLE_APPROVED,
  NOTIFICATION_TYPE.DELIVERABLE_SUBMITTED,
  NOTIFICATION_TYPE.DELIVERABLE_ALMOST_DUE,
  NOTIFICATION_TYPE.DELIVERABLE_DUE,
  NOTIFICATION_TYPE.COMPLETE_KYC,
  NOTIFICATION_TYPE.KYC_APPROVED,
  NOTIFICATION_TYPE.KYC_REJECTED,
  NOTIFICATION_TYPE.REVIEWER_PROFILE_TEMPORARILY_BLOCKED,
  NOTIFICATION_TYPE.REVIEWER_PROFILE_PERMANENTLY_BLOCKED,
  NOTIFICATION_TYPE.REVIEWER_PROFILE_REINSTATED,
];

export const NOTIFICATION_REDIRECTS: Partial<Record<NOTIFICATION_TYPE, string>> = {
  [NOTIFICATION_TYPE.GRANT_APPLICATION_CREATED]: "/activity",
  [NOTIFICATION_TYPE.GRANT_APPLICATION_APPROVED]: "/activity",
  [NOTIFICATION_TYPE.GRANT_APPLICATION_REJECTED]: "/activity",
  [NOTIFICATION_TYPE.GRANT_APPLICATION_WITHDRAWN]: "/activity",
  [NOTIFICATION_TYPE.CONTRACT_SENT]: "/activity",
  [NOTIFICATION_TYPE.WALLET_VERIFIED]: "/activity",
  [NOTIFICATION_TYPE.DELIVERABLE_REJECTED]: "/activity",
  [NOTIFICATION_TYPE.DELIVERABLE_APPROVED]: "/activity",
  [NOTIFICATION_TYPE.DELIVERABLE_SUBMITTED]: "/activity",
  [NOTIFICATION_TYPE.DELIVERABLE_ALMOST_DUE]: "/activity",
  [NOTIFICATION_TYPE.DELIVERABLE_DUE]: "/activity",
  [NOTIFICATION_TYPE.COMPLETE_KYC]: "/activity",
  [NOTIFICATION_TYPE.KYC_APPROVED]: "/activity",
  [NOTIFICATION_TYPE.KYC_REJECTED]: "/activity",
};

export const notificationTypeColors: Record<string, string> = {
  draft: "bg-warning",
  active: "bg-light-green",
  expired: "bg-red-400",
  archived: "bg-sky-500",
};
